import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as qs from 'query-string';

import { resetPassword } from '../user/actions';

import LoggedInPasswordResetForm from './forms/password-reset-logged-in-form';
import TokenPasswordResetForm from './forms/password-reset-token-form';
import RequestPasswordResetForm from './forms/password-reset-request-form';

const mapStateToProps = state => ({
  global: state.Global
});

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: null
    }
    this.dispatchResetPassword = this.dispatchResetPassword.bind(this);
    this.loggedInOnSubmit = this.loggedInOnSubmit.bind(this);
    this.onBack = this.onBack.bind(this);

  }

  componentWillMount() {
    if (this.props.global.userId
      && window.location.hash.indexOf("resetpassword") >= 0) {
      this.props.history.replace('/dashboard');
      return;
    }
    let query = {};
    if (location.search) {
      query = qs.parse(location.search, { ignoreQueryPrefix: true });
    } else if (location.hash.indexOf('?') > -1) {
      query = qs.parse(location.hash.substr(location.hash.indexOf('?')), { ignoreQueryPrefix: true });
    }
    if (query.t) {
      this.setState({ token: query.t });
    }
  }

  onBack() {
    let { history } = this.props;
    history.goBack();
  }

  dispatchResetPassword = (values, setSubmitting) => {
    let { dispatch } = this.props;
    dispatch(resetPassword(values));
    setSubmitting(false);
  }

  loggedInOnSubmit = (values, { setSubmitting }) => this.dispatchResetPassword(values, setSubmitting)

  tokenOnSubmit = (values, { setSubmitting }) => this.dispatchResetPassword(values, setSubmitting)

  requestOnSubmit = (values, { setSubmitting }) => this.dispatchResetPassword(values, setSubmitting)

  render() {
    let { global } = this.props;
    let { token } = this.state;
    let error = global.errors
      ? global.errors.find((e) => { return (e.errType === "resetpassword") })
      : null;
    if (global.userId) {
      return (<LoggedInPasswordResetForm userId={global.userId} error={error} onSubmit={this.loggedInOnSubmit} onBack={this.onBack} />)
    } else if (token) {
      return (<TokenPasswordResetForm token={token} error={error} onSubmit={this.tokenOnSubmit} onBack={this.onBack} />)
    } else {
      return (<RequestPasswordResetForm error={error} onSubmit={this.requestOnSubmit} onBack={this.onBack} />)
    }
  }
}

export default withRouter(connect(mapStateToProps)(ResetPassword));
